export default __webpack_public_path__ + "static/media/smallgoldpile.1fa359e6.png";